import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function LangToggle() {
  const { lang, setLang, t } = useLanguage();
  return (
    <button
      type="button"
      onClick={() => setLang(lang === 'en' ? 'te' : 'en')}
      style={{
        background: 'rgba(0,214,143,0.1)',
        border: '1px solid rgba(0,214,143,0.3)',
        borderRadius: 20,
        padding: '6px 12px',
        color: 'var(--green)',
        fontSize: 12,
        fontWeight: 700,
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
      aria-label={t('profile.language')}
    >
      {lang === 'en' ? 'తెలుగు' : 'EN'}
    </button>
  );
}
